import { render, staticRenderFns } from "./UPhotoUpload.vue?vue&type=template&id=f43f47d4&"
import script from "./UPhotoUpload.vue?vue&type=script&lang=js&"
export * from "./UPhotoUpload.vue?vue&type=script&lang=js&"
import style0 from "./UPhotoUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports